import React from "react";

/** Custom fields: a small form with labelled input boxes. */
const CustomFieldsIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3.5" y="3" width="17" height="18" rx="2" stroke="currentColor" strokeWidth="1.7" />
      <path d="M7 7h4.5M7 13h4.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
      <rect x="7" y="8.6" width="10" height="2.4" rx="0.8" fill="currentColor" />
      <rect x="7" y="14.6" width="10" height="2.4" rx="0.8" fill="currentColor" />
    </svg>
  );
};

export default CustomFieldsIcon;
